var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "time-tracking__customer hover-highlight q-py-xs q-px-sm row items-center no-wrap",
      class: { "bg-grey-2": _vm.active, "cursor-pointer": _vm.clickable },
      on: {
        click: function($event) {
          _vm.$emit("click", $event)
        }
      }
    },
    [
      !_vm.hideIcon
        ? _c("q-icon", { attrs: { name: _vm.icon, color: "grey-6" } })
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "q-subheading text-faded block ellipsis",
          class: { "on-right": !_vm.hideIcon }
        },
        [_vm._v(_vm._s(_vm.customerName))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }